<!-- Landing Page -->
<div class="container-fluid"
  [ngClass]="this.language == null || this.language === 'en' ? 'pre-login-en-css' : 'pre-login-other-css'"
  style="display: flex; flex-direction: column; min-height: 100vh;">
  <div class="row flex-grow-1" style="flex: 1;display: flex;">
    <div class="col-md-6 p-md-0 col-lg-7 bg-alice">
      <app-main-sidebar></app-main-sidebar>
    </div>
    <div class="col-md-6 col-lg-5">
      <div class="">
        <app-login *ngIf="!signUp" (isSignUp)="isSignUp($event)"></app-login>
        <app-signup *ngIf="signUp" (isLogin)="isSignUp($event)"></app-signup>
      </div>
    </div>
  </div>
  <div class="footer-container">
    <app-footer [login]="login"></app-footer>
  </div>
</div>